<a *ngIf="isStaff" href="/admin/user-management/{{getUserRole()}}/{{user.id}}">{{user.firstName}} {{user.lastName}}</a>
<p *ngIf="!isStaff" >{{user.firstName}} {{user.lastName}}</p>